enum EntityType {
  BLOCK = 'block',
  BUTTON = 'button',
  NODE = 'node',
}

export default EntityType
